const ExtensionsConstants = {
    JPG: 'jpg',
    JPEG: 'jpeg',
    PNG: 'png',
    BMP: 'bmp',
    GIF: 'gif',
};

export default ExtensionsConstants;
